module.exports = __webpack_public_path__ + "static/goldberg-machine-86ad4c59932e9375439850081ea46039.svg";